import {resolveBackground} from '#core/utils/color-utils.js';

import {generateAvantgardeOddsButton} from '#core/application/modules/cards-and-promotions/avantgarde-cards/avantgarde-event-card-common.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';

const CARD_PORTRAIT_WIDTH = 230;
const CARD_PORTRAIT_HEIGHT = 294;

export function avantgardeCardsFactory(PALETTE) {
    return {
        BaseEventCard: {
            container: {
                style: {
                    width: CARD_PORTRAIT_WIDTH,
                    height: CARD_PORTRAIT_HEIGHT,
                    ...resolveBackground(PALETTE.CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.CARD_BORDER),
                },
            },
        },
        CardBackground: {
            sportWatermark: {
                container: {
                    style: {
                        top: 8,
                    },
                },
            },
        },
        SportWatermarkImage: {
            sportIcon: {
                icon: {
                    style: {
                        fill: PALETTE.CARD_WATERMARK_ICON_COLOR,
                        opacity: PALETTE.CARD_WATERMARK_ICON_OPACITY,
                    },
                },
            },
        },
        EventCardsCarousel: {
            swiper: {
                ...(PALETTE.CARD_BORDER.BORDER_SHOW_SHADOW
                    ? {
                          style: {
                              padding: '5px 1px 10px',
                              _mobile_padding: '5px 8px 10px',
                          },
                      }
                    : {}),
                slide: {
                    style: {
                        flexBasis: CARD_PORTRAIT_WIDTH,
                    },
                },
            },
        },
        ...(PALETTE.CARD_BORDER.BORDER_SHOW_SHADOW
            ? {
                  PrebuiltBets: {
                      swiper: {
                          style: {
                              padding: '5px 1px 10px',
                              _mobile_padding: '5px 8px 10px',
                          },
                      },
                  },
              }
            : {}),
        PropCard: {
            showBadgeRow: true,
            contentBackgroundTarget: 'jersey',
            container: {
                style: {
                    minHeight: 220,
                },
            },
            selectionButton: generateAvantgardeOddsButton(PALETTE.CARD_ODDS_BUTTON),
        },
        EventCardSkeleton: {
            container: {
                itemSpacing: '12px',
                style: {
                    width: CARD_PORTRAIT_WIDTH,
                    height: CARD_PORTRAIT_HEIGHT,
                    padding: '12px',
                    ...resolveBackground(PALETTE.CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.CARD_BORDER),
                },
            },
            participantNameSkeleton: {
                style: {
                    width: '100px',
                },
            },
            matchSelectionSkeleton: {
                style: {
                    width: '64px',
                    height: '36px',
                },
            },
        },
        ProView: {
            eventCardsCarousel: {
                headerContainer: {
                    style: {
                        padding: '0 0 8px 0',
                    },
                },
            },
        },
    };
}
